import { useEffect } from 'react';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { clearCustomersData, fetchCustomerById } from '../../../slices/customers/customersSlice';
import { RootState } from '../../../store';

export const useCustomerDetails = (customerId: number) => {
  const dispatch = useAppDispatch();
  const customer = useAppSelector((state: RootState) => state.customers.currentCustomerData);
  const status = useAppSelector((state: RootState) => state.customers.status);
  const error = useAppSelector((state: RootState) => state.customers.error);

  useEffect(() => {
    if (customerId) {
      dispatch(fetchCustomerById(customerId));
    }
    return () => {
      dispatch(clearCustomersData());
    };
  }, [customerId, dispatch]);

  return { customer, status, error };
};
